import * as React from 'react';
import { useRef } from 'react';
export default function useRefs() {
  var cacheRefs = useRef(new Map());

  function getRef(key) {
    if (!cacheRefs.current.has(key)) {
      cacheRefs.current.set(key, /*#__PURE__*/React.createRef());
    }

    return cacheRefs.current.get(key);
  }

  function removeRef(key) {
    cacheRefs.current.delete(key);
  }

  return [getRef, removeRef];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tabs/es/hooks/useRefs.js
// module id = 749
// module chunks = 0